module.exports = __webpack_public_path__ + "img/8.42cb84a7.jpg";